/*
 Copyright 2026 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the
 project root for license information.
*/

/**
 * Cite API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ItemStatus = {
    Pending: 'Pending',
    Active: 'Active',
    Cancelled: 'Cancelled',
    Complete: 'Complete',
    Archived: 'Archived'
} as const;
export type ItemStatus = typeof ItemStatus[keyof typeof ItemStatus];

